import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closetdsModal, fetchTDS, opentdsModal } from "./store/tdsSlice";
import TDSDataTable from "./TDSDataTable";
import AddTDS from "./AddTDS";

const TDS = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.tdsData || {});

  useEffect(() => {
    dispatch(fetchTDS());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="TDS "
            title="Dashboard"
            subtitle="TDS"
            name="Import TDS"
            onAddClick={() => dispatch(opentdsModal())}
          />

          <TDSDataTable data={data} loading={loading} />

          <AddTDS
            show={isModalOpen}
            onClose={() => dispatch(closetdsModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default TDS;
